import React from "react";
import { createRoot } from "react-dom/client";
import Spinner from "@amzn/awsui-components-core/spinner";

import App from "./components/App";
import ErrorBoundary from "./components/ErrorBoundary";
import { startSessionRenewal } from "./services/session";
import "./logger";

// Keep the Federate session alive for the full Midway SSO session by renewing
// the ID token as it approaches expiry (no-op outside production). See
// services/session.ts for the renewal strategy (route-preserving reload today;
// swappable for a silent server refresh-token flow).
startSessionRenewal();

import "@amzn/awsui-global-styles/polaris.css";
import "./index.scss";

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <React.Suspense fallback={<Spinner size="large" />}>
        <App />
      </React.Suspense>
    </ErrorBoundary>
  </React.StrictMode>
);
